import type { Conversation } from "../api/types";

/** Which agent is the analyst — remembered per Fountain URL, in this browser. */

/** The channel the analyst's current conversation is bound to; each new dataset rotates it. */
export const CHANNEL = "table-talk";
const KEY = "table-talk.analyst";

export function loadAnalystId(baseUrl: string): string | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const map = JSON.parse(raw) as Record<string, string>;
    return typeof map[baseUrl] === "string" ? map[baseUrl] : null;
  } catch {
    return null;
  }
}

export function saveAnalystId(baseUrl: string, agentId: string): void {
  let map: Record<string, string> = {};
  try {
    map = JSON.parse(localStorage.getItem(KEY) ?? "{}") as Record<string, string>;
  } catch {
    // start over
  }
  map[baseUrl] = agentId;
  localStorage.setItem(KEY, JSON.stringify(map));
}

export function clearAnalystId(baseUrl: string): void {
  try {
    const map = JSON.parse(localStorage.getItem(KEY) ?? "{}") as Record<string, string>;
    delete map[baseUrl];
    localStorage.setItem(KEY, JSON.stringify(map));
  } catch {
    localStorage.removeItem(KEY);
  }
}

/** A one-word status for the rail, from the channel's current conversation. */
export function presenceLabel(conv: Conversation | null): string {
  if (!conv) return "ready";
  switch (conv.status) {
    case "pending":
      return "starting";
    case "running":
      return "working";
    case "idle":
      return "online";
    default:
      return conv.status;
  }
}
